export default "__VITE_ASSET__yr8jCiGX__"